import PropTypes from 'prop-types'

// A single page link within a product's navigation.
export const navLinkType = PropTypes.shape({
  label: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  href: PropTypes.string,
  active: PropTypes.bool,
  // Locked pages render with a padlock badge and are not navigable.
  locked: PropTypes.bool,
  // Not-yet-shipped pages render muted with a "Coming soon" tag.
  comingSoon: PropTypes.bool,
})

// A product the supplier is signed up to. Each product owns its own rail icon,
// panel heading and set of nav links. The new design is organised by product:
// switching the active product swaps the panel heading and links.
export const productType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  // Heading shown at the top of the nav panel when this product is active.
  name: PropTypes.string.isRequired,
  // Icon shown in the product switcher rail.
  icon: PropTypes.node.isRequired,
  links: PropTypes.arrayOf(navLinkType).isRequired,
})

export const utilityActionType = PropTypes.shape({
  key: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  href: PropTypes.string,
  onClick: PropTypes.func,
  hasNotification: PropTypes.bool,
})

export const balanceType = PropTypes.shape({
  amount: PropTypes.string.isRequired,
  unit: PropTypes.string.isRequired,
})

export const accountType = PropTypes.shape({
  initial: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  // Fired when the account row is clicked and there is no menu.
  onClick: PropTypes.func,
  // Link to the accounts page, shown as the menu's last item. `current`
  // highlights it as the selected item (used on the accounts page itself).
  viewAll: PropTypes.shape({
    label: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    current: PropTypes.bool,
  }),
  // The businesses listed in the menu (the consumer caps how many); selecting
  // one switches to it.
  businesses: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      initial: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      // Highlights the business the login is currently signed in to.
      current: PropTypes.bool,
      onSelect: PropTypes.func.isRequired,
    }),
  ),
})
